<template>
  <a-table :scroll="{ x: 1600 }" :pagination="false" :columns="columns" size="middle" :data-source="issueList" :loading="loading" row-key="id">
    <span slot="issueTitle" slot-scope="text, record">
      <a-tooltip placement="top" :title="record.title">
        <a class="custom-link" :href="issueLink(record)" target="_blank"> {{ record.title }} </a>
      </a-tooltip>
    </span>
    <span slot="tag" slot-scope="text, record">
      <a-popover placement="topLeft">
        <template slot="content">
          <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
        </template>
        <template slot="title">
          <span>缺陷标签</span>
        </template>
        <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
      </a-popover>
    </span>
    <span slot="priority" slot-scope="text, record">
      <a-tag v-if="record.priority" :color="issuePrioritys[record.priority].color"> {{ issuePrioritys[record.priority].label }} </a-tag>
      <span v-else>--</span>
    </span>
    <span slot="status" slot-scope="text, record">
      <a-tag :color="issueStatus[record.status].color"> {{ issueStatus[record.status].label }}</a-tag>
    </span>
    <span slot="type" slot-scope="text, record">
      {{ record.issue_type ? issueTypes[record.issue_type].label : '--' }}
    </span>
    <span slot="serious" slot-scope="text, record">
      {{ record.serious !== null ? issueSerious[record.serious].label : '--' }}
    </span>
    <span slot="handler" slot-scope="text, record"><user-profiles :value="[record.handler.id]" avatar /></span>
    <span slot="creator" slot-scope="text, record"><user-profiles :value="[record.creator.id]" avatar /></span>
    <span slot="verifier" slot-scope="text, record"><user-profiles :value="[record.verifier.id]" avatar /></span>
  </a-table>
</template>

<script>
import { issuePrioritys, issueTypes, issueSerious, issueStatus } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 110,
    ellipsis: true
  },
  {
    title: '标题',
    width: 480,
    ellipsis: true,
    scopedSlots: { customRender: 'issueTitle' }
  },
  {
    title: '状态',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '类型',
    width: 100,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '优先级',
    width: 100,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '缺陷等级',
    width: 100,
    scopedSlots: { customRender: 'serious' }
  },
  {
    title: '处理人',
    width: 100,
    scopedSlots: { customRender: 'handler' }
  },
  {
    title: '验证人',
    width: 100,
    scopedSlots: { customRender: 'verifier' }
  },
  {
    title: '创建人',
    width: 100,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    width: 168,
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '更新时间',
    width: 168,
    dataIndex: 'updated_time',
    key: 'updated_time'
  }
];
export default {
  name: 'StoryIssueList',
  props: {
    issueList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      issuePrioritys,
      issueTypes,
      issueSerious,
      issueStatus
    };
  },
  computed: {
    issueLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          query: { issueId: record.id }
        });
        return route.href;
      };
    },
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    }
  }
};
</script>

<style scoped>
.custom-link:hover {
  cursor: pointer;
  color: #1890ff;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
</style>
